import { Component, ContentChild, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { Action, ActionEvent, CollectionTemplate } from '../../collection.model';

@Component({
	selector: 'app-grid',
	templateUrl: './grid.component.html',
	styleUrls: ['./grid.component.scss']
})
export class GridComponent implements OnChanges {
	@Input() template: CollectionTemplate;
	@Input() entities: any[];
	@Input() page = 1;
	@Input() limit = 10;
	@Input() limitOptions = [10, 25, 50, 100]
	@Input() totalResults = 0;
	@Input() paginationMode: 'more' | 'paginator' = 'more';

	@Output() updatePagination: EventEmitter<PageEvent & { append?: boolean }> = new EventEmitter<PageEvent & { append?: boolean }>();
	@Output() updateSort: EventEmitter<Sort> = new EventEmitter<Sort>();
	@Output() action: EventEmitter<ActionEvent> = new EventEmitter<ActionEvent>();

	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ContentChild(TemplateRef) cardTemplate: TemplateRef<any>;

	constructor() { }

	ngOnChanges(changes: SimpleChanges) {
		if (changes.template) {
			if (changes.template.currentValue.settings.limitOptions) {
				this.limitOptions = changes.template.currentValue.settings.limitOptions;
			}
		}
	}

	inputsHaveErrors() {
		if (!this.template) {
			console.error('TableContainerComponent: No template input defined', this.template);
			return true;
		}

		if (!this.template.settings.columns) {
			console.error('TableContainerComponent: No columns defined in template', this.template);
			return true;
		}

		if (!this.template.settings.activeColumns) {
			console.error('TableContainerComponent: No activeColumns defined in template', this.template);
			return true;
		}
	}

	onActionEvent(entity: any, action: Action) {
		this.action.emit({
			entity,
			action
		})
	}

	trackByFn(index, item) {
		return item.id;
	}

}
